import React from 'react';
import { CustomerSignupCard } from '../../components/CustomerSignupCard';

import MerchantLayout from '../../layout/MerchantLayout';


export const MerchantCustomerSignupPage: React.FC = () => 
  <MerchantLayout>
    <CustomerSignupCard />
  </MerchantLayout>


